import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass({ required: _ctx.input.required })
      }, _toDisplayString(_ctx.input.label), 3)
    ]),
    _createVNode(_component_Multiselect, {
      placeholder: 'Select ' + _ctx.input.label,
      options: _ctx.options || [],
      search: true,
      searchable: true,
      mode: _ctx.input.value === 'multiple' ? 'multiple' : 'single',
      "close-on-select": _ctx.input.value !== 'multiple',
      "clear-on-select": _ctx.input.value !== 'multiple',
      "value-prop": "id",
      label: _ctx.labelProp,
      object: false,
      "can-clear": _ctx.input.canClear,
      "hide-selected": false,
      disabled: _ctx.disabled,
      autocomplete: _ctx.input.autocomplete || 'off',
      "input-type": _ctx.input.inputType || 'search',
      "multiple-label": _ctx.multipleLabel,
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event))
    }, null, 8, ["placeholder", "options", "mode", "close-on-select", "clear-on-select", "label", "can-clear", "disabled", "autocomplete", "input-type", "multiple-label", "modelValue"]),
    _createVNode(_component_Field, {
      type: "hidden",
      name: _ctx.input.name,
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event))
    }, null, 8, ["name", "modelValue"]),
    _createVNode(_component_ErrorMessage, {
      name: _ctx.input.name
    }, null, 8, ["name"])
  ]))
}